import { EnumSpreadshirtProduct, EnumSpreadshirtSorting } from '../../../../../../constants/research';
import { ISearchParameterConfig } from '../../../../data/search-links.interface';
import { AbstractSearchLinks } from '../../../../data/search-links.abstract';
import { SPREADSHIRT_CONFIG_DE } from './spreadshirt-de.data';
import { ISpreadshirtSearchOptions, SPREADSHIRT_DEFAULT_OPTIONS } from '../spreadshirt-search.data';


/**------------------------------------------------------
 * Spreadshirt DE Search Links
 */
export class SpreadshirtDeSearch extends AbstractSearchLinks<ISpreadshirtSearchOptions> {

	//** Helper Getters */
	get sortingList(): ISearchParameterConfig<EnumSpreadshirtSorting>[] {
		return SPREADSHIRT_CONFIG_DE.sortings as ISearchParameterConfig<EnumSpreadshirtSorting>[];
	}

	get productList(): ISearchParameterConfig<EnumSpreadshirtProduct>[] {
		return SPREADSHIRT_CONFIG_DE.products as ISearchParameterConfig<EnumSpreadshirtProduct>[];
	}

	constructor() {
		super(SPREADSHIRT_CONFIG_DE, SPREADSHIRT_DEFAULT_OPTIONS);
	}
}
